import { sendNotification } from '../../utils/test-push';

(function () {
  function animatePush() {
    const push = document.querySelector('.js-push-animated');
    const pushPos = window.pageYOffset + push.getBoundingClientRect().top;
    if (window.scrollY + 500 >= pushPos  && push.classList.contains('push-animated') && window.matchMedia('(min-width: 1200px)').matches) {
      push.classList.remove('push-animated');
      window.removeEventListener('scroll', animatePush);
    }
  }
  
  window.addEventListener('scroll', animatePush);


  const sendTestPush = document.querySelector('.js-send-test-push');
  sendTestPush.addEventListener('click', () => {
    setTimeout(() => {
      Notification.requestPermission(function () {
        sendNotification();
      });
    }, 60000);
  })

})();